import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e18c941"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-2" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showSchemeFromVehicleBack)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "image",
              src: `data:image/png;base64, ${_ctx.model.endViewScheme}`
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.topViewSchemes, (topViewScheme, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (_ctx.showSchemeLevels && _ctx.model.topViewSchemes.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("strong", null, "Вид сверху. Ярус № " + _toDisplayString((index as number) + 1), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              class: "image",
              src: `data:image/png;base64, ${topViewScheme}`
            }, null, 8, _hoisted_6)
          ])
        ]))
      }), 128)),
      (_ctx.showSchemeCuts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.verticalCutSchemes, (verticalCutScheme, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, "Вид сбоку. Разрез № " + _toDisplayString((index as number) + 1) + "-" + _toDisplayString((index as number) + 1), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    class: "image",
                    src: `data:image/png;base64, ${verticalCutScheme}`
                  }, null, 8, _hoisted_8)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}